export default class Utils {
    static plural(n, f) {
        n %= 100;
        if (n > 10 && n < 20) return f[2];
        n %= 10;
        return f[n > 1 && n < 5 ? 1 : n === 1 ? 0 : 2];
    }

    static valueAtPath = (object, path, def) =>
        path.reduce((r, p) => (r && r.hasOwnProperty(p) ? r[p] : def), object);

    /**
     * Format bytes as human-readable text.
     *
     * @param bytes Number of bytes.
     * @param si True to use metric (SI) units, aka powers of 1000. False to use
     *           binary (IEC), aka powers of 1024.
     * @param dp Number of decimal places to display.
     *
     * @return Formatted string.
     */
    static humanFileSize = (bytes, si = true, dp = 1) => {
        if (Math.abs(bytes) < 1024) {
            return bytes + ' B';
        }

        const units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        let u = -1;
        const r = 10 ** dp;

        do {
            bytes /= 1024;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= 1024 && u < units.length - 1);

        return bytes.toFixed(dp) + ' ' + units[u];
    };
}
